import { listPools, assetUnitLabel, type Pool } from "../lib/pools";
import { fmtAmount } from "../lib/format";
import { usePoolStats } from "../lib/useStats";

export function PoolPicker({
  value,
  onChange,
  label = "Pool denomination",
}: {
  value: string;
  onChange: (key: string) => void;
  label?: string;
}) {
  const pools = listPools();
  return (
    <div className="picker">
      <p className="picker__label">{label}</p>
      <div className="picker__grid" role="radiogroup" aria-label={label}>
        {pools.map((p) => (
          <PoolTile
            key={p.key}
            pool={p}
            active={p.key === value}
            disabled={!p.address}
            onSelect={() => p.address && onChange(p.key)}
          />
        ))}
      </div>
    </div>
  );
}

function PoolTile({
  pool,
  active,
  disabled,
  onSelect,
}: {
  pool: Pool;
  active: boolean;
  disabled?: boolean;
  onSelect: () => void;
}) {
  const stats = usePoolStats(pool.key);
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      disabled={disabled}
      onClick={onSelect}
      className={`pool-tile ${active ? "pool-tile--active" : ""} ${
        disabled ? "pool-tile--disabled" : ""
      }`}
    >
      <span className="pool-tile__amount">{fmtAmount(pool.amount)}</span>
      <span className="pool-tile__unit">{assetUnitLabel(pool)}</span>
      {disabled ? (
        <span className="pool-tile__badge">soon</span>
      ) : (
        <span className="pool-tile__set">
          {stats ? `${stats.anonymitySetSize.toLocaleString()} in set` : "loading…"}
        </span>
      )}
    </button>
  );
}
